// extracted by mini-css-extract-plugin
module.exports = {"Hint":"nft-marketplace-transfer_Hint__Tl_Jl"};